/**
 * Initials in a coloured circle, used wherever a person is listed.
 *
 * The colour is derived from the name rather than the row index, so the same person is the same
 * colour on the dashboard, the candidate list and the report — which is the whole point of having it.
 */
const PALETTE = [
    '#e11d48', '#7c3aed', '#0891b2', '#059669',
    '#d97706', '#4f46e5', '#db2777', '#0d9488'
] as const;

export function initialsOf(name: string): string {
    const parts = (name ?? '').trim().split(/\s+/).filter(Boolean);

    if (parts.length === 0) return '?';

    // First and last, so "No Email Person" reads NP rather than NE.
    const first = parts[0]![0]!;
    const last = parts.length > 1 ? parts[parts.length - 1]![0]! : '';

    return (first + last).toUpperCase();
}

export function colourOf(name: string): string {
    let hash = 0;

    for (const char of name ?? '') {
        hash = (hash * 31 + char.charCodeAt(0)) | 0;
    }

    return PALETTE[Math.abs(hash) % PALETTE.length]!;
}

export function Avatar({ name }: { name: string }) {
    return (
        <span
            className="avatar-initial"
            style={{ background: colourOf(name) }}
            aria-hidden="true"
        >
            {initialsOf(name)}
        </span>
    );
}
